import { render, staticRenderFns } from "./SetStory.vue?vue&type=template&id=5a8e1927"
import script from "./SetStory.vue?vue&type=script&lang=js"
export * from "./SetStory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports